<template>
    <popup-modal-confirm
        :confirm-text="$t('general.export')"
        :has-close-button="true"
        :title="$t('general.export')"
        :use-portal="false"
        :working="exporting"
        confirm-button="success"
        @close="$emit('close')"
        @confirm="exportApplications"
    >
        <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-24 mt-24">
            <toggle v-for="(label, field) in exportFields"
                    :key="'field-' + field"
                    v-model="checkedFields"
                    :value="field"
            >
                {{ $t(label) }}
            </toggle>
        </div>

        <a ref="downloadLink" :download="file.name" :href="file.url">
            {{ file.name }}
        </a>
    </popup-modal-confirm>
</template>

<script>
import PopupModal from './PopupModal.vue';
import SimpleButton from './SimpleButton.vue';
import Toggle from '../forms/Toggle.vue';
import * as applications from '../../services/ApplicationService';
import {mapState} from 'pinia';
import {useMainStore} from '../../state/store';
import PopupModalConfirm from './PopupModalConfirm';

export default {
    components: {
        PopupModalConfirm,
        'popup-modal': PopupModal,
        'simple-button': SimpleButton,
        'toggle': Toggle,
    },
    props: {
        requestFilters: {
            type: Object,
            required: true,
        },
        applications: {
            type: Array,
            required: true,
        },
        stages: {
            type: Array,
            required: true,
        },
    },
    data: function () {
        return {
            exportFields: {
                created_at: 'applications.created_at',
                first_name: 'applications.first_name',
                last_name: 'applications.last_name',
                job: 'applications.job',
                email: 'applications.email',
                phone_number: 'applications.phone',
                birthdate: 'applications.birthdate',
                street: 'applications.street',
                house_number: 'applications.house_number',
                postal_code: 'applications.postal_code',
                city: 'applications.city',
                rijksregister_nr: 'applications.ssn',
                iban_nr: 'applications.iban',
                motivation: 'applications.motivation',
                external_partner: 'applications.interim',
                stage: 'applications.stage',
                rating: 'applications.rating',
                status: 'applications.status',
                tags: 'applications.tags',
                dynamic_questions: 'applications.extra_questions',
            },
            checkedFields: [],
            exporting: false,
            file: {
                name: null,
                url: null,
            },
        };
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
    },
    methods: {
        exportApplications() {

            this.exporting = true;

            applications.download(
                {
                    locale: this.locale,
                    ...this.requestFilters,
                },
                {
                    applications: this.applications,
                    stages: this.stages,
                },
                this.checkedFields,
            ).then(result => {
                if (typeof result.file != 'undefined') {
                    this.file.url = result.file;
                    this.file.name = result.filename;
                }
            }).then(() => {
                if (this.file.url) {
                    this.$refs.downloadLink.click();
                }
            }).then(() => {
                this.exporting = false;
                this.$emit('close');
            });
        },
    },
    mounted() {
        this.checkedFields = Object.keys(this.exportFields);
    },
};
</script>
